import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { openSpinnerDialog } from "@app/modules/ui-notification/SpinnerDialog/spinner-dialog.component";
import { hidden } from "@fuse/services/splash-screen";
import { BehaviorSubject, delay, of, Subject, takeUntil, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoadingNotifierService {

    

    private readonly itemsToShow = 
    {
        "api/query/units" : 'units', 
        "api/query/element-name/esef-notes" : 'ESEF note metrics', 
        "api/query/element-name/esef-tables" : 'ESEF table metrics', 
        "api/query/element-name/us" : 'US table metrics', 
        'api/issuer/issuerlist' : 'Issuer list', 
        'api/issuer/issuer-all' : 'All Issuer list', 
        "api/query/metrics": 'Common metrics', 
        'api/query/metric-superclass-cube' : 'Corporatings metrics', 
        'api/issuer/sectors' : 'Issuer sectors', 
        'api/metric-list/all': 'User metric list', 
        'api/query/tags' : 'Financial statement metrics', 
        'api/query/element-labels': 'Metric labels',
        'api/llm/models' : 'LLM Models', 
    }

    extractTitleFromURL(url) {
        const keys = Object.keys(this.itemsToShow)
        const r = keys.find(k => url.includes(k))
        if(r) return this.itemsToShow[r]
        return null
    }

    private _loadingList: Record<string, number> = {}
    private _matDialog = inject(MatDialog)
    private _messageSubject: BehaviorSubject<string>
    readonly delay = 500
    readonly stopDelay = new Subject<any>()


    addLoading(url: string) {
        const title = this.extractTitleFromURL(url)
        if(!title) return
        console.log('Adding', url, title)
        this.stopDelay.next(null)
        if (title in this._loadingList) {
            this._loadingList[title]++
        }
        else {
            this._loadingList[title] = 1
        }
        of(null).pipe(delay(this.delay), takeUntil(this.stopDelay), tap(_ => this.postProcess())).subscribe()
    }

    removeLoading(url: string) {
        const title = this.extractTitleFromURL(url)
        if(!title) return
        console.log('Removing', url, title)
        this.stopDelay.next(null)
        if (title in this._loadingList) {
            this._loadingList[title]--
            if (!this._loadingList[title]) {
                delete this._loadingList[title]
            }
        }
        of(null).pipe(delay(500), takeUntil(this.stopDelay), tap(_ => this.postProcess())).subscribe()
    }

    postProcess() {
        const keys = Object.keys(this._loadingList)
        if (!keys.length) {
            if (this._messageSubject)
                this._messageSubject.complete()
            this._messageSubject = null
        }
        else {
            if (!this._messageSubject && !this._matDialog.openDialogs.length && hidden) {
                this._messageSubject = new BehaviorSubject<string>("Loading data")
                openSpinnerDialog(this._matDialog, this._messageSubject)
                this._messageSubject.next(`Loading ${keys[0]}`)
            }
            else if (this._messageSubject) {
                this._messageSubject.next(`Loading ${keys[0]}`)
            }
        }
    }

}

